import { t } from 'i18next';
import dayjs from 'dayjs';
import type { IValidationField } from '../types';
import startDate from './startDate';

export default function endDate(field: IValidationField) {
  const { label = '', context: { startDateLabel = '' } = {} } = field;

  return startDate(field).test(
    'greaterThanStartDate',
    t('errors.minDate', {
      label,
      minDate: startDateLabel,
    }),
    (value, testContext) => {
      const {
        parent: { startDate },
      } = testContext;
      if (value) {
        return dayjs(value).isSameOrAfter(startDate || dayjs().startOf('day'));
      }
      return true;
    },
  );
}
